import { createFileRoute } from '@tanstack/react-router'
import SmartQcDashboard from '@/components/smartqc-dashboard-route'
import { navigateGuard } from '@/utils/auth'
import { UserRole } from '@/constants/user'

export const Route = createFileRoute('/_auth/smart-qc/dashboard/')({
  beforeLoad: ({ location }) => {
    return navigateGuard(location, [UserRole.ADMINISTRATOR])
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <SmartQcDashboard />
}
